import React, { Component, Fragment } from "react";
import CollapseMenu from "../../../../config/atoms/CollapseMenu";
import MenuDetail from "../MenuDetail";
import swal from "sweetalert";
import { dataJadwal } from "../../../../dummy-data/jadwal";
import { dataMahasiswa } from "../../../../dummy-data/mahasiswa";
import { dataKRS } from "../../../../dummy-data/krs-khs";
const $ = require("jquery");
$.Datatable = require("datatables.net");

class JadwalMhs extends Component {
    state = {
        user: {
            angkatan: '',
            jurusan: '',
            kdjur: '',
            kurikulum: '',
            nama: '',
            nim: '',
            semester: '',
            smtta: '',
            ta: ''
        },
        OptJadwal: [],
        listJadwalDiajukan: [],
        checkListPengajuan: [],
        checkListOpt: [],
        isLoading: false,

        // params
        idVal: '',
        nimVal: ''
    }

    parserText = (val) => {
        var txt = document.createElement("textarea");
        txt.innerHTML = val;
        return txt.value;
    }

    getAllData = () => {
        const nim = this.state.nimVal;
        const mhs = dataMahasiswa.find(m => m.nim === nim);

        this.setState({
            user: {
                angkatan: mhs ? mhs.angkatan : '2020',
                jurusan: mhs ? mhs.prodi : 'Teknik Informatika',
                kdjur: 'TI',
                kurikulum: '2020',
                nama: mhs ? mhs.nama : 'Mahasiswa Demo',
                nim: nim,
                semester: 7,
                smtta: 'Ganjil',
                ta: '2024/2025'
            }
        }, () => {
            this.getListJadwal();
        });
    }

    getListJadwal = () => {
        $('.cekJadwal').prop("checked", false);

        const nim = this.state.nimVal;

        // Get KRS data for this student
        const krsData = dataKRS.filter(k => k.nim === nim);

        // Map jadwal yang sudah dipilih
        const jadwalDiajukan = krsData.map(k => ({
            idkrs: k.krs_id,
            idjadwal: k.jadwal_id,
            kodemk: k.kode_mk,
            namamk: k.nama_mk,
            sksteori: k.sks,
            skspraktek: 0,
            kddosen: 'DSN001',
            namadosen: k.dosen,
            jalur: 'Pagi',
            periode: '-',
            ruangan: 'R.101',
            hari: 'Senin',
            jam: '07:00-08:40',
            kelas: k.kelas,
            statuskelas: 'Aktif',
            bu: 'B'
        }));

        // Get available jadwal (not yet selected)
        const selectedJadwalIds = krsData.map(k => k.jadwal_id);
        const availableJadwal = dataJadwal
            .filter(j => !selectedJadwalIds.includes(j.jadwal_id) && j.prodi_id === 1)
            .map(j => ({
                idkrs: null,
                idjadwal: j.jadwal_id,
                kodemk: j.kode_mk,
                namamk: j.nama_mk,
                sksteori: j.sks,
                skspraktek: 0,
                dosen: j.dosen_nama,
                jalur: 'Pagi',
                periode: '-',
                ruangan: j.ruangan,
                hari: j.hari,
                jam: `${j.jam_mulai}-${j.jam_selesai}`,
                kelas: j.kelas,
                isi: `${j.terisi}/${j.kapasitas}`,
                statuskelas: 'Aktif',
                bu: 'B'
            }));

        this.setState({
            OptJadwal: availableJadwal,
            listJadwalDiajukan: jadwalDiajukan,
            checkListOpt: [],
            checkListPengajuan: []
        });
    }

    toggleOpt = (event, selectedVal) => {
        const data = {
            idkrs: selectedVal.idkrs,
            idjadwal: selectedVal.idjadwal
        }

        if (event.target.checked) {
            this.state.checkListOpt.push(data)
        } else {
            var index = this.state.checkListOpt.findIndex(x => x.idjadwal === data.idjadwal);
            this.state.checkListOpt.splice(index, 1);
        }
    }

    togglePengajuan = (event, selectedVal) => {
        const data = {
            idkrs: selectedVal.idkrs,
            idjadwal: selectedVal.idjadwal
        }

        if (event.target.checked) {
            this.state.checkListPengajuan.push(data)
        } else {
            var index = this.state.checkListPengajuan.findIndex(x => x.idjadwal === data.idjadwal);
            this.state.checkListPengajuan.splice(index, 1);
        }
    }

    ProcessSimpan = () => {
        const { checkListOpt } = this.state;

        if (checkListOpt.length === 0) {
            swal({ icon: 'warning', title: 'Peringatan', text: 'Pilih jadwal terlebih dahulu!' });
        } else {
            swal({
                icon: 'success',
                title: 'Demo Mode',
                text: 'Jadwal berhasil disimpan (simulasi)',
                timer: 1500,
                buttons: false
            });
        }
    }

    setBatal = () => {
        const { checkListPengajuan } = this.state;

        if (checkListPengajuan.length === 0) {
            swal({ icon: 'warning', title: 'Peringatan', text: 'Pilih jadwal terlebih dahulu!' });
        } else {
            swal({
                icon: 'success',
                title: 'Demo Mode',
                text: 'Jadwal berhasil dibatalkan (simulasi)',
                timer: 1500,
                buttons: false
            });
        }
    }

    setUlang = () => {
        const { checkListPengajuan } = this.state;

        if (checkListPengajuan.length === 0) {
            swal({ icon: 'warning', title: 'Peringatan', text: 'Pilih jadwal terlebih dahulu!' });
        } else {
            swal({
                icon: 'success',
                title: 'Demo Mode',
                text: 'Jadwal berhasil diulang (simulasi)',
                timer: 1500,
                buttons: false
            });
        }
    }

    setParams = () => {
        const queryParams = new URLSearchParams(window.location.search);
        this.setState({
            idVal: queryParams.get('id'),
            nimVal: queryParams.get('nim')
        }, () => {
            this.getAllData();
        })
    }

    componentDidMount() {
        document.getElementById("jadwalMenu").classList.add("active");
        CollapseMenu();

        this.setParams()
    };

    render() {
        const { angkatan, jurusan, nama, nim, semester, ta } = this.state.user
        const { listJadwalDiajukan, OptJadwal, isLoading } = this.state

        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p
                                className="abu"
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                    color: "#999999",
                                    textTransform: "capitalize",
                                }}
                            >
                                Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;
                                Detail Jadwal
                            </p>
                        </div>
                        <div className="col-12 col-xl-4 sm-md-none">
                            <div className="justify-content-end d-flex ">
                                <div
                                    style={{ cursor: "pointer" }}
                                    title="expand/minimize"
                                    id="toogleMenu"
                                >
                                    <i className="fa fa-expand abu" id="iconQ"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" id="smoothMain">

                    <div className="col-xl-3 order-xl-2 smoothTabs" id="menuKanan">
                        <MenuDetail id={this.state.idVal} nim={this.state.nimVal} />
                    </div>

                    <div className="col-xl-9" id="kontenKiri">
                        <div className="card card-custom">
                            <div className="card-body">
                                <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                    Pilih Jadwal
                                </p>
                                <div className="table-responsive">
                                    <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                        <thead></thead>
                                        <tbody>
                                            <tr>
                                                <td>NIM</td>
                                                <td> : </td>
                                                <td>{nim}</td>

                                                <td>Angkatan</td>
                                                <td> : </td>
                                                <td>{angkatan}</td>
                                            </tr>
                                            <tr>
                                                <td>Nama</td>
                                                <td> : </td>
                                                <td>{this.parserText(nama)}</td>

                                                <td>Tahun Akademik</td>
                                                <td> : </td>
                                                <td>{ta}</td>
                                            </tr>
                                            <tr>
                                                <td>Prodi</td>
                                                <td> : </td>
                                                <td>{jurusan}</td>
                                                <td>Semester</td>
                                                <td> : </td>
                                                <td>{semester}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br />
                                <br />
                                <p className="card-title" style={{ fontSize: "17px", marginLeft: "10px" }}>
                                    Jadwal Yang Dipilih :
                                </p>
                                <div className="table-responsive mt-3">
                                    <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th>
                                                    Pilih
                                                </th>
                                                <th>No</th>
                                                <th>Kode MK</th>
                                                <th>Mata Kuliah</th>
                                                <th>SKS Teori</th>
                                                <th>SKS Praktek</th>
                                                <th>Kode Dosen</th>
                                                <th>Periode</th>
                                                <th>Ruang</th>
                                                <th>Hari</th>
                                                <th>Jam</th>
                                                <th>Kelas</th>
                                                <th>Status Kelas</th>
                                                <th>B/U</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                listJadwalDiajukan.map((v, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <input type="checkbox"
                                                                    className="cekJadwal"
                                                                    onChange={(e) => this.togglePengajuan(e, v)} />
                                                            </td>
                                                            <td>{index + 1}</td>
                                                            <td>{v.kodemk}</td>
                                                            <td>{v.namamk}</td>
                                                            <td>{v.sksteori}</td>
                                                            <td>{v.skspraktek}</td>
                                                            <td><a href='#' title={v.namadosen}>{v.kddosen}</a></td>
                                                            <td>{v.jalur === "Malam" ? v.periode : '-'}</td>
                                                            <td>{v.ruangan}</td>
                                                            <td>{v.hari}</td>
                                                            <td>{v.jam}</td>
                                                            <td>{v.kelas}</td>
                                                            <td>{v.statuskelas}</td>
                                                            <td>{v.bu}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <br />
                                <p align="right">
                                    <button onClick={this.setBatal} id="btnSetBatal" className="btn btn-warning" disabled={isLoading}>
                                        set batal
                                    </button>
                                    &nbsp;&nbsp;
                                    <button onClick={this.setUlang} id="btnSetUlang" className="btn btn-danger" disabled={isLoading}>
                                        set ulang
                                    </button>
                                </p>

                            </div>
                        </div>

                        <div className="card card-custom mt-4">
                            <div className="card-body">
                                <p className="card-title" style={{ fontSize: "17px", marginTop: "10px", marginLeft: '1%' }}>
                                    Pilihan Jadwal Kuliah :
                                </p>
                                <div className="table-responsive">
                                    <table id="Jadwal" className="display expandable-table tableBord table-striped" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>Pilih</th>
                                                <th>No</th>
                                                <th>Kode MK</th>
                                                <th>Mata Kuliah</th>
                                                <th>SKS Teori</th>
                                                <th>SKS Praktek</th>
                                                <th>Nama Dosen</th>
                                                <th>Periode</th>
                                                <th>Ruang</th>
                                                <th>Hari</th>
                                                <th>Jam</th>
                                                <th>Kelas</th>
                                                <th>Isi Kelas</th>
                                                <th>Status Kelas</th>
                                                <th>B/U</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                OptJadwal.map((v, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td><input type="checkbox"
                                                                className="cekJadwal"
                                                                onChange={(e) => this.toggleOpt(e, v)} /></td>
                                                            <td>
                                                                {index + 1}
                                                            </td>
                                                            <td>{v.kodemk}</td>
                                                            <td>{v.namamk}</td>
                                                            <td>{v.sksteori}</td>
                                                            <td>{v.skspraktek}</td>
                                                            <td>{v.dosen}</td>
                                                            <td>{v.jalur === "Malam" ? v.periode : '-'}</td>
                                                            <td>{v.ruangan}</td>
                                                            <td>{v.hari}</td>
                                                            <td>{v.jam}</td>
                                                            <td>{v.kelas}</td>
                                                            <td>{v.isi}</td>
                                                            <td>{v.statuskelas}</td>
                                                            <td>{v.bu}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <br />
                                <p align="right">
                                    {OptJadwal.length > 0 &&
                                        <button className="btn btn-success" id="btnSimpan" onClick={this.ProcessSimpan} disabled={isLoading}>
                                            simpan jadwal
                                        </button>
                                    }
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </Fragment>
        );
    }
}

export default JadwalMhs;